import { render, staticRenderFns } from "./agents.vue?vue&type=template&id=10c93916&scoped=true"
import script from "./agents.vue?vue&type=script&lang=js"
export * from "./agents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c93916",
  null
  
)

export default component.exports